// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    applicationId: z.string().min(1).max(21),
    organizationId: z.string().min(1).max(21),
    organizationRoleId: z.string().min(1).max(21),
});
const guard = z.object({
    tenantId: z.string().max(21),
    applicationId: z.string().min(1).max(21),
    organizationId: z.string().min(1).max(21),
    organizationRoleId: z.string().min(1).max(21),
});
export const ApplicationAccessControlOrgRoleRelations = Object.freeze({
    table: 'application_access_control_org_role_relations',
    tableSingular: 'application_access_control_org_role_relation',
    fields: {
        tenantId: 'tenant_id',
        applicationId: 'application_id',
        organizationId: 'organization_id',
        organizationRoleId: 'organization_role_id',
    },
    fieldKeys: [
        'tenantId',
        'applicationId',
        'organizationId',
        'organizationRoleId',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
